export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'a',
'_.loadingSpinnerText': 'Počkejte prosím...',
'pageTimerMax.text': 'Po uplynutí času budete automaticky přesměrováni na další stránku.',
'pageTimerMax.timeLeft': 'Zbývající čas',
'pageTimerMin.text': 'Před vypršením času není možné přejít dále.',
'pageTimerMin.timeLeft': 'Zbývající čas',
'pageTimerMin.allowNext': 'Můžete pokračovat dále',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Chci dostávat zpravodaj',
'survey.registerForm.label.regulations': 'Souhlasím se zásadami ochrany osobních údajů a smluvními podmínkami',
'survey.registerForm.button.register': 'Registrace',
'survey.registerForm.registered': 'Děkujeme za registraci. Do vaší e-mailové schránky byl zaslán e-mail s aktivačním odkazem.',
'survey.registerForm.cardHeader': 'Zaregistrujte se a získávejte body!',
'survey.registerForm.cardBody': 'Za vyplnění dotazníku jste obdrželi',
'survey.registerForm.cardBody2': 'Body vám budou připsány po registraci účtu na swpanel.co.uk. Zadejte svou e-mailovou adresu a zaregistrujte si účet na adrese swpanel.pl.',
'survey.notProperDevice': 'Na tomto zařízení bohužel nelze tento průzkum vyplnit.',
'survey.properDevices': 'Průzkum lze provést z následujících zařízení:',
'survey.device-phone': 'chytrý telefon',
'survey.device-tablet': 'tabletu',
'survey.device-desktop': 'počítač / notebook',
'nextSurveys.header.seeAlso': 'Podívejte se také na další průzkumy',
'nextSurveys.button.fill': 'Vyplňte',
'question.noContent': 'Chybí obsah otázky',
'question.input.placeholder.typeYourAnswer': 'Zadejte svou odpověď',

'question.conjoint.go': 'Klikněte na tlačítko "Další"',
'question.matrix.carousel.go': 'Klikněte na tlačítko "Další"',
'question.carousel.prevBtn': 'Předchozí výrok',
'question.carousel.nextBtn': 'Další výrok',

'question.open.email.inputPlaceholder': 'Zadejte e-mailovou adresu',
'question.open.email.emailVerify.sendCode': 'Odeslat ověřovací kód',
'question.open.email.emailVerify.enderCode': 'Zadejte obdržený kód',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Zadejte kód',
'question.open.email.emailVerify.confirm': 'Potvrďte',
'question.open.email.emailVerify.codeIncorrect': 'Zadaný kód je nesprávný',
'question.open.email.emailVerify.codeCorrect': 'E-mailová adresa byla správně ověřena',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Zastavit vyplňování',
'footer.buttonPrev.text': 'Zpět',
'footer.buttonClear.text': 'Vymazat',
'footer.buttonNext.text': 'Další',
'footer.buttonEnd.text': 'Dokončit',
'footer.buttonStart.text': 'Spustit průzkum',
'question.matrix.nextStatement': 'Další výrok',
'question.matrix.previousStatement': 'Předchozí výrok',
};
